import type { Tutorial } from '.';
import type { TutorialStep } from './tutorial.ruleset';
import { assertNever } from '../../utils';

export const tutorialModifiers = ({ tutorial }: Tutorial.MutableState) => ({
  setTutorialStepComplete(step: TutorialStep) {
    switch (step) {
      case 'basicGameplay':
        tutorial.basicGameplayShown = true;
        break;

      case 'careForPets':
        tutorial.careForPetsShown = true;
        break;

      case 'chatWithPets':
        tutorial.chatWithPetsShown = true;
        break;

      case 'petsGetSick':
        tutorial.petSickShown = true;
        break;

      case 'friendReferral':
        tutorial.friendReferralShown = true;
        break;

      case 'profile':
        tutorial.profileShown = true;
        break;

      case 'match3':
        tutorial.match3Shown = true;
        break;

      case 'visitFriend':
        tutorial.visitFriendShown = true;
        break;

      case 'adult':
        tutorial.adult = true;
        break;

      case 'duoInvite':
        tutorial.duoInvite = true;
        break;

      case 'duoInviteReceived':
        tutorial.duoInviteReceived = true;
        break;

      default:
        assertNever(step);
    }
  },
});
